export enum WebSocketMethods {
  ping = 'ping',
  students_available_count = 'students_available_count',
  students_available_count_contract_id = 'students_available_count_contract_id',
  debug = 'DEBUG_LOG'
}
